// extracted by mini-css-extract-plugin
module.exports = {"text":"common-modal_text__dKINT","footer":"common-modal_footer__37_WY"};